<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="url(#paint0_radial_35_2160)" />
    <rect width="32" height="32" rx="16" fill="url(#paint1_radial_35_2160)" />
    <rect width="32" height="32" rx="16" fill="url(#paint2_radial_35_2160)" />
    <path
      d="M24.4286 9.71415C24.4286 10.6609 23.6611 11.4284 22.7143 11.4284C21.7675 11.4284 21 10.6609 21 9.71415C21 8.76737 21.7675 7.99986 22.7143 7.99986C23.6611 7.99986 24.4286 8.76737 24.4286 9.71415Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.4286 21.7141C19.5845 21.7141 22.1429 19.1558 22.1429 15.9999C22.1429 12.8439 19.5845 10.2856 16.4286 10.2856C13.2727 10.2856 10.7143 12.8439 10.7143 15.9999C10.7143 19.1558 13.2727 21.7141 16.4286 21.7141ZM16.4286 19.4284C18.3221 19.4284 19.8571 17.8934 19.8571 15.9999C19.8571 14.1063 18.3221 12.5713 16.4286 12.5713C14.535 12.5713 13 14.1063 13 15.9999C13 17.8934 14.535 19.4284 16.4286 19.4284Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 15.5427C5 11.7024 5 9.78218 5.74738 8.31535C6.4048 7.0251 7.45381 5.97609 8.74406 5.31867C10.2109 4.57129 12.1311 4.57129 15.9714 4.57129H16.8857C20.7261 4.57129 22.6463 4.57129 24.1131 5.31867C25.4033 5.97609 26.4523 7.0251 27.1098 8.31535C27.8571 9.78218 27.8571 11.7024 27.8571 15.5427V16.457C27.8571 20.2974 27.8571 22.2175 27.1098 23.6844C26.4523 24.9746 25.4033 26.0236 24.1131 26.681C22.6463 27.4284 20.7261 27.4284 16.8857 27.4284H15.9714C12.1311 27.4284 10.2109 27.4284 8.74406 26.681C7.45381 26.0236 6.4048 24.9746 5.74738 23.6844C5 22.2175 5 20.2974 5 16.457V15.5427ZM15.9714 6.857H16.8857C18.8436 6.857 20.1746 6.85878 21.2033 6.94284C22.2054 7.02471 22.7179 7.17311 23.0754 7.35526C23.9356 7.79354 24.6349 8.49288 25.0732 9.35305C25.2553 9.71053 25.4037 10.223 25.4856 11.2251C25.5697 12.2539 25.5714 13.5848 25.5714 15.5427V16.457C25.5714 18.4149 25.5697 19.7459 25.4856 20.7746C25.4037 21.7767 25.2553 22.2892 25.0732 22.6467C24.6349 23.5068 23.9356 24.2062 23.0754 24.6445C22.7179 24.8266 22.2054 24.975 21.2033 25.0569C20.1746 25.1409 18.8436 25.1427 16.8857 25.1427H15.9714C14.0135 25.1427 12.6826 25.1409 11.6538 25.0569C10.6517 24.975 10.1392 24.8266 9.78176 24.6445C8.92159 24.2062 8.22225 23.5068 7.78397 22.6467C7.60182 22.2892 7.45342 21.7767 7.37155 20.7746C7.28749 19.7459 7.28571 18.4149 7.28571 16.457V15.5427C7.28571 13.5848 7.28749 12.2539 7.37155 11.2251C7.45342 10.223 7.60182 9.71053 7.78397 9.35305C8.22225 8.49288 8.92159 7.79354 9.78176 7.35526C10.1392 7.17311 10.6517 7.02471 11.6538 6.94284C12.6826 6.85878 14.0135 6.857 15.9714 6.857Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_35_2160"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.4286 24) rotate(-55.3758) scale(29.1653)"
      >
        <stop stop-color="#B13589" />
        <stop offset="0.79309" stop-color="#C62F94" />
        <stop offset="1" stop-color="#8A3AC8" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_35_2160"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.2857 33.1429) rotate(-65.1363) scale(25.822)"
      >
        <stop stop-color="#E0E8B7" />
        <stop offset="0.444662" stop-color="#FB8A2E" />
        <stop offset="0.71474" stop-color="#E2425C" />
        <stop offset="1" stop-color="#E2425C" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_35_2160"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-1.71428 1.14286) rotate(-8.1301) scale(44.4467 9.50669)"
      >
        <stop offset="0.156701" stop-color="#406ADC" />
        <stop offset="0.467799" stop-color="#6A45BE" />
        <stop offset="1" stop-color="#6A45BE" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
</template>
